module.exports = __webpack_public_path__ + "img/close.e8907919.svg";